import { titleDescriptions } from 'constants/reportTitleDescription';

export interface IReportingState {
  loading: boolean;
  date: string;
  is_displayed: boolean;
  is_additional_displayed: boolean;
  headers: string[];
  dataReport99: any;
  function_id: number;
  ictService_id: number;
  ict_system_by_function: number;
  ict_system_by_ict_service: number;
  financial_entity_lei_id: number;
}

export interface DataTypeAR {
  key: React.Key;
  entity_name: string;
  function_description: string;
  function_level: number;
  function_name: string;
  ict_service_level: string;
  ict_service_provider_name: string;
  function_end_date: string;
  function_start_date: string;
  ict_service_end_date: string;
  ict_service_start_date: string;
  date: string;
}

export interface DataTypeReportData {
  key: React.Key;
  entity_name: string;
  date: string;
  start_date: string;
  sensitiveness_of_data_stored_by_ict_tpsp: number;
  sensitiveness: number;
  location_of_data_management: 'string';
  location_of_data_at_rest: string;
  id: number;
  ict_system_name: number;
  end_date: string;
  description: string;
}

export interface DataTypeReportFunctions {
  key: React.Key;
  entity_name: string;
  date: string;
  alternatives_exit: string;
  criticality_assessment: string;
  date_of_last_assessment: string;
  description: string;
  dora_criticality: string;
  end_date: string;
  function_identifier: string;
  function_level: string;
  function_name: string;
  impact_of_discontinuing: string;
  licensed_activity: string;
  possibility_of_reintegration: string;
  reasons_for_criticality: string;
  recovery_point_objective: string | number;
  recovery_time_objective: string | number;
  start_date: string;
}

export interface DataTypeReportICTServices {
  key: React.Key;
  entity_name: string;
  date: string;
  alternatives_exit: string;
  auswahl_services_discount: string;
  contractual_arrangement: string;
  country: string;
  criticality_assessment: string;
  end_date: string;
  exit_plan_exists: string;
  function_name: string;
  ict_service_description: string;
  ict_service_level: string;
  ict_service_type: string;
  ict_services_criticality: string;
  impact_of_discontinuing_function: string;
  impact_of_discontinuing_ict_services: string;
  level_of_reliance: string;
  level_of_supporting_ict_service: string;
  local_regulator_criticality: string;
  notice_period: string;
  possibility_of_reintegration: string;
  rank: string | number;
  recipient_identification_code: string;
  recipient_identification_type: string;
  start_date: string;
  storage_of_data: string;
  substitutability_of_ict_provider: string;
  third_party_service_provider_name: string;
  tpp_code_type: string;
}

export interface DataTypeReportICTSystems {
  key: React.Key;
  entity_name: string;
  date: string;
  end_date: string;
  function_name: string;
  function_description: string;
  ict_service_description: string;
  ict_system_description: string;
  ict_system_name: string;
  start_date: string;
}

export interface DataTypeReportTPP {
  key: React.Key;
  entity_name: string;
  date: string;
  add_ict_service_provider_identification_code: string | null;
  add_identification_code_type: string;
  alternative_providers_identified: string;
  alternatives_exit: string;
  criticality_assessment: string;
  description: string;
  dora_criticality: string;
  dora_regulator_criticality: string;
  dora_regulator_criticality_label: string;
  end_date: string;
  entity_nature: string;
  exit_plan_exists: string;
  headquarters_country: string;
  ict_service_provider_identification_code: string;
  ict_service_provider_lei: string;
  identification_code_type: string;
  iso_code: string;
  last_audit_date: string;
  local_regulator_criticality: string;
  non_subst_reason: string;
  notice_period: number;
  person_type: string;
  possibility_of_reintegration: string;
  rank: number | string;
  recipient_identification_code: string;
  recipient_identification_type: string;
  start_date: string;
  substitutability: boolean;
  substitutability_of_ict_provider: string;
  third_party_service_provider_legal_name: string;
  third_party_service_provider_name: string;
  tpp_code_type: string;
  ultimate_parent_identification_code: string;
  ultimate_parent_identification_code_type: string;
}

export interface DataCertificates {
  key: React.Key;
  certificate_registry: string;
  date_of_certificate_register: string;
  date_of_issuance: string;
  description: string;
  end_date: string;
  function_id: null | number;
  ict_service_id: number;
  ict_service_name: string;
  id: number;
  start_date: string;
  third_party_service_provider_id: number | null;
  validity: string;
  certificate_source?: 'Function' | 'ICT Service';
}

export interface DataCertificatesICTSystem {
  id?: number;
  certificate_id?: number;
  ict_service_id?: number;
  ict_service_name?: string;
  function_id?: number;
  function_name?: string;
  certificate_source?: 'Function' | 'ICT Service';
  description?: string;
  certificate_registry?: string;
  contractual_arrangement_name?: string;
  date_of_certificate_register?: string;
  date_of_issuance?: string;
  end_date?: string;
  start_date?: string;
  ict_service_description?: string;
  ict_system_name?: string;
  name_of_entity?: string;
  third_party_provider_name?: string;
  third_party_service_provider_id?: number;
  validity?: string;
}

export interface EntitiesByLei {
  key: React.Key;
  name_of_entity: string;
  lei_maintaining_register: string;
  head_office_lei: string;
  financial_reporting_date: string;
  financial_entity_type_name: string;
  financial_entity_name: string;
  financial_country_name: string;
  financial_competent_authority_name: string;
  entity_start_date: string;
  entity_end_date: string;
  branch_start_date: string;
  branch_name: string;
  branch_identification_code: string;
  branch_end_date: string;
  branch_competent_authority: string;
}
export type TitleKey = keyof typeof titleDescriptions;

export interface ReportModalProps {
  title: string | TitleKey;
  headers: string[];
  tableNumber: string;
  description?: string;
}

export interface DataTypeB0101 {
  key: React.Key;
  lei_entity: string;
  entity_name: string;
  iso_code: string;
  entity_type: string;
  competent_authority: string;
  reporting_date: string;
  date: string;
}

export interface BProps {
  entityName: string | null | undefined;
}

export interface DataTypeB0102 {
  key: React.Key;
  country_name: string;
  currency: string;
  date_of_last_update: string;
  deletion_date: string;
  entity_name: string;
  entity_type: string;
  hierarchy_in_group: string;
  integration_date: string;
  lei_entity: string;
  parent_lei: string;
  total_assets: string;
  date: string;
}

export interface DataTypeB0103 {
  key: React.Key;
  branch_identification_code: string;
  branch_name: string;
  country_id: number;
  head_office_lei: string;
  date: string;
  entity_name: string;
}

export interface DataTypeB0201 {
  key: React.Key;
  annual_expense: string;
  arrangement_reference_number: string;
  contract_type: string;
  currency: string;
  overarching_reference_number: string;
  date: string;
  entity_name: string;
}

export interface DataTypeB0202 {
  key: React.Key;
  contractual_arangement_ref_num: string;
  country_of_ict_services: string;
  data_location_processing: string;
  data_location_storage: string;
  data_sensitiveness: string;
  end_date: string;
  entity_notice_period: number;
  function_identifier: string;
  governing_law_country: string;
  ict_service_provider_code: string;
  lei_of_the_entity_using_ict_service: string;
  level_of_reliance: string;
  provider_notice_period: string;
  start_date: string;
  storage_of_data: string;
  termination_reason: string;
  type_of_ict_service_provider_code: string;
  type_of_ict_services: string;
  date: string;
  entity_name: string;
}

export interface DataTypeB0203 {
  key: React.Key;
  arrangement_reference_number: string;
  linked_contractual_arrangement: string;
  link: boolean;
  date: string;
  entity_name: string;
}

export interface DataTypeB0301 {
  key: React.Key;
  arrangement_reference_number: string;
  lei_entity_signing_contractual_arrangement: string;
  link: boolean;
  date: string;
  entity_name: string;
}

export interface DataType0302 {
  key: React.Key;
  contractual_arangement_ref_num: string;
  identification_code: string;
  type_of_code: string;
  link: boolean;
  date: string;
  entity_name: string;
}

export interface DataTypeB0303 {
  key: React.Key;
  arrangement_reference_number: string;
  ict_service_provider_lei: string;
  link: boolean;
  date: string;
  entity_name: string;
}

export interface DataTypeB0401 {
  key: React.Key;
  arrangement_reference_number: string;
  branch_identification_code: string;
  lei_entity_making_use_ICT_service: string;
  nature_of_entity: string;
  date: string;
  entity_name: string;
}

export interface DataTypeB0501 {
  key: React.Key;
  identification_code_of_ICT_provider: string;
  type_of_code: string;
  name_of_the_ICT_provider: string;
  type_of_person: string;
  country: string;
  currency_reported: string;
  total_annual_expense: string;
  identification_code_of_ICT_providers_ultimate_parent: string;
  type_of_code_to_identify_ultimate_parent: string;
  additional_code: string;
  type_of_additional_code: string;
  legal_name: string;
  date: string;
  entity_name: string;
}

export interface DataTypeB0502 {
  key: React.Key;
  contractual_arrangement_ref_number: string;
  type_of_ICT: string;
  identification_code_of_ICT_provider: string;
  type_of_code_to_identify_provider: string;
  rank: string;
  identification_code_of_recipient: string;
  type_of_code_to_identify_recipient: string;
  date: string;
  entity_name: string;
}

export interface DataTypeB0601 {
  key: React.Key;
  function_identifier: string;
  licenced_identifier: string;
  function_name: string;
  lei_of_financial_entity: string;
  criticality_assessment: string;
  reasons_for_criticality: string;
  date_of_last_assessment: string;
  recovery_time_objective: string;
  recovery_point_objective: string;
  impact_of_discontinuing_function: string;
  date: string;
  entity_name: string;
}

export interface DataTypeB0701 {
  key: React.Key;
  contractual_arrangement_reference_number: string;
  identification_code_of_ICT_provider: string;
  type_of_code_of_ICT_provider: string;
  type_of_ICT_services: string;
  sustainability_of_ICT_provider: string;
  reason_of_substitutable: string;
  date_of_last_audit: string;
  existance_of_exit_plan: string;
  possibility_of_reintegration: string;
  impact_of_discontinuing_ICT_services: string;
  alternative_ICT_identified: string;
  identification_of_alternative_ICT_TPP: string;
  date: string;
  entity_name: string;
}

export interface RecordType99 {
  id: number;
  option: string;
  dataTxt: string;
  dataDesc: string;
  dataPoint: string;
  rowSpan?: number;
}

export const labelToCodeMap: Record<string, string> = {
  'Type of contractual arrangements': 'RT.02.01.0020',
  'Impact of discontinuing the function': 'RT.02.01.0170',
  'Impact of discontinuing the ICT services': 'RT.06.01.0110',
  'Possibility of reintegration of the contracted ICT service': 'RT.07.01.0050',
  'Sensitiveness of the data stored by the ICT third-party service provider':
    'RT.07.01.0090',
  'Substitutability of the ICT third-party service provider': 'RT.07.01.0100',
};

export const labelToKeyMap: Record<string, string> = {
  'Type of contractual arrangements': 'type_of_contractual_arrangement',
  'Impact of discontinuing the function': 'impact_of_discontinuing_function',
  'Impact of discontinuing the ICT services':
    'impact_of_discontinuing_ict_services',
  'Possibility of reintegration of the contracted ICT service':
    'possibility_of_reintegration',
  'Sensitiveness of the data stored by the ICT third-party service provider':
    'sensitiveness_of_data_stored_by_ict_tpsp',
  'Substitutability of the ICT third-party service provider':
    'substitutability_of_ict_provider',
};

export interface IRoles {
  entity_end_date: string;
  entity_id: number;
  entity_name: string;
  entity_reporting_date: string;
  entity_start_date: string;

  role_name: string;
  role_description: string;
  role_type: string;

  responsibilities: IResponsibility[];
}

export interface IResponsibility {
  responsibility_description: string | null;
  responsibility_name: string | null;
  responsibility_start_date: string | null;
  responsibility_end_date: string | null;
}

export interface IRiskSource {
  risk_source_description: string;
  risk_source_end_date: string;
  risk_source_id: number | string;
  risk_source_name: string;
  risk_source_start_date: string;
}

export interface IIctRisk {
  entity_name: string;
  entity_end_date: string;
  entity_id: number;
  entity_reporting_date: string;
  entity_start_date: string;
  ict_risk_active: boolean | null;
  ict_risk_description: string;
  ict_risk_end_date: string;
  ict_risk_id: number;
  ict_risk_name: string;
  ict_risk_start_date: string;
  ict_system_description: string;
  ict_system_end_date: string;
  ict_system_id: number;
  ict_system_name: string;
  ict_system_start_date: string;
  risk_exposure_description: string;
  risk_exposure_id: number;
  risk_exposure_name: string;
  risk_level_description: string;
  risk_level_id: number;
  risk_level_name: string;
  risk_source: IRiskSource[];
}

export interface IIctRisksResponse {
  ict_risks: IIctRisk[];
}

export interface IIctRiskExposure {
  dependency_type_description: string;
  dependency_type_name: string;
  entity_end_date: string;
  entity_name: string;
  entity_reporting_date: string;
  entity_start_date: string;
  exposure_category_description: string;
  exposure_category_name: string;
  ict_risk_name: string;
  ict_system_end_date: string;
  ict_system_name: string;
  ict_system_start_date: string;
  risk_exposure_description: string;
  risk_exposure_end_date: string;
  risk_exposure_name: string;
  risk_exposure_start_date: string;
  contract_name: string;
  ict_service_name: string;
  tpp_name: string;
}

export interface ICTRiskResponse {
  entity_id: number;
  ict_risks: ICTRiskFunctionServiceDetails[];
}

export interface ICTRiskFunctionServiceDetails {
  dependency_type_description: string;
  dependency_type_id: number;
  dependency_type_name: string;

  contract_name?: string;
  tpp_name?: string;

  entity_end_date: string;
  entity_name: string;
  entity_reporting_date: string;
  entity_start_date: string;

  exposure_category_description: string;
  exposure_category_id: number;
  exposure_category_name: string;

  function_end_date: string;
  function_id: number;
  function_name: string;
  function_start_date: string;

  ict_system_end_date: string;
  ict_system_id: number;
  ict_system_name: string;
  ict_system_start_date: string;

  risk_active: boolean;
  risk_deleted: boolean;
  risk_description: string;
  risk_end_date: string;

  risk_exposure_active: boolean;
  risk_exposure_description: string;
  risk_exposure_end_date: string;
  risk_exposure_id: number;
  risk_exposure_name: string;
  risk_exposure_start_date: string;

  risk_id: number;
  risk_level_id: number;
  risk_level_name: string;

  risk_name: string;
  risk_source_id: number;
  risk_source_name: string;
  risk_start_date: string;
}

export interface ICTSystem {
  access_restricted: boolean;
  active: boolean;
  data: ICTSystemData[];
  description: string;
  end_date: string;
  entity_id: number;
  function: ICTFunction;
  ict_risks: any[];
  ict_system_category_id: number;
  ict_system_category_name: string;
  ict_system_criticality: any | null;
  ict_system_criticality_id: number | null;
  ict_system_id: number;
  ict_system_site: string;
  ict_system_type_id: number;
  ict_system_type_name: string;
  name: string;
  start_date: string;
}

export interface ICTFunction {
  description: string;
  function_identifier: string;
  function_name: string;
  id: number;
}

export interface ICTSystemData {
  id: number;
  active: boolean;
  description: string;
  start_date: string;
  end_date: string;
  ict_system_id: number;

  site: string;

  sensitiveness_id: number | null;
  sensitiveness_of_data: {
    id: number;
    name: string;
    description: string;
  } | null;

  location_of_data_at_rest: {
    id: number;
    country_name: string;
    iso_code: string;
  };

  location_of_data_management: {
    id: number;
    country_name: string;
    iso_code: string;
  };
}

export interface LocationForService {
  country_name: string;
  id: number;
  iso_code: string;
}

export interface DataFieldForService {
  id: number;
  ict_system_id: number;
  description: string;
  start_date: string;
  end_date: string;
  active: boolean;
  site?: string;
  sensitiveness_of_data?: {
    id: number;
    name: string;
    description: string;
  } | null;
  location_of_data_at_rest?: LocationForService | null;
  location_of_data_management?: LocationForService | null;
}

interface ICTRiskForService {
  ict_risk_name: string;
  ict_risk_description: string;
}

interface ICTServiceForService {
  id: number;
  description: string;
  start_date: string;
  end_date: string;
  active: boolean;
}

export interface ICTSystemForService {
  access_restricted: boolean;
  active: boolean;
  data: DataFieldForService[];
  description: string;
  end_date: string;
  entity_id: number;
  ict_risks: ICTRiskForService[];
  ict_service: ICTServiceForService;
  ict_system_category_id: number;
  ict_system_category_name: string;
  ict_system_criticality: any | null;
  ict_system_criticality_id: number | null;
  ict_system_id: number;
  ict_system_site: string | null;
  ict_system_type_id: number;
  ict_system_type_name: string;
  name: string;
  start_date: string;
}

export interface ICTFunction {
  id: number;
  description: string;
  function_identifier: string;
  function_name: string;
}

export interface ICTSystemForFunction {
  access_restricted: boolean;
  active: boolean;
  data: any | null;
  description: string;
  entity_id: number;
  function: ICTFunction;
  ict_risks: ICTRiskForService[];
  ict_system_category_id: number;
  ict_system_category_name: string;
  ict_system_criticality: string | null;
  ict_system_criticality_id: number | null;
  ict_system_id: number;
  ict_system_site: string | null;
  ict_system_type_id: number;
  ict_system_type_name: string;
  name: string;
}

export interface SystemOption {
  label: string;
  value: string | number;
  key?: string | number;
}

export type TableItem = {
  title: string;
  description: string;
};
